import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBracketsCurlyIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M6 6a2 2 0 0 1 2-2 1 1 0 0 0 0-2 4 4 0 0 0-4 4v3a2 2 0 0 1-2 2 1.0002 1.0002 0 0 0-.7071 1.7071C1.4804 12.8946 1.7348 13 2 13a1.9999 1.9999 0 0 1 2 2v3a3.9998 3.9998 0 0 0 4 4 1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 8 20a1.9999 1.9999 0 0 1-2-2v-3a4.0003 4.0003 0 0 0-1.38-3A4.0005 4.0005 0 0 0 6 9V6Zm16 5a2 2 0 0 1-2-2V6a3.9998 3.9998 0 0 0-4-4 1 1 0 1 0 0 2 2 2 0 0 1 2 2v3a4 4 0 0 0 1.38 3A4.0008 4.0008 0 0 0 18 15v3a2 2 0 0 1-2 2 1.0001 1.0001 0 0 0 0 2 3.9996 3.9996 0 0 0 2.8284-1.1716A3.9996 3.9996 0 0 0 20 18v-3a2 2 0 0 1 2-2 1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineBracketsCurlyIcon
